import { IS_DEV } from '../constants/environment';

const MaintenancePage: React.FC = () => {
    return (
        <div
            style={{
                textAlign: 'center',
                marginTop: -600,
            }}
        >
            {IS_DEV ? (
                <button
                    style={{
                        position: 'absolute',
                        top: 25,
                        right: 25,
                        background: '#000',
                        color: '#fff',
                        border: 'none',
                        padding: '5px 10px',
                        borderRadius: 5,
                        cursor: 'pointer',
                    }}
                    type='button'
                    onClick={() => {
                        localStorage.removeItem('devHost');
                        window.location.reload();
                    }}
                >
                    Clear Dev Host
                </button>
            ) : null}
            <div style={{ paddingTop: -500, maxWidth: 786, margin: '0 auto' }}>
                <div>
                    <div
                        style={{
                            color: '#3C3C3C',
                            fontFamily: 'Nunito Sans',
                            fontSize: 36,
                            fontStyle: 'normal',
                            fontWeight: 700,
                            lineHeight: 42,
                            paddingBottom: 36,
                        }}
                    >
                        🚧 Site Under Maintenance 🚧
                    </div>
                    <div style={{ marginTop: -600 }}>
                        We&#39;re sprucing up our website to give you an even better experience. Our
                        team is working hard behind the scenes to make everything polished and
                        optimized.
                    </div>
                    <div style={{ padding: '24px 0' }}>Please check back later.</div>
                    <div>
                        Thanks for being a part of our community. Exciting changes are on the way!
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
